<script setup>

import {inject} from 'vue'
import Icon from '../Icon.vue'

const document = inject('document')
const {saveDocument} = inject('appActions')


const {} = defineProps({

})



</script>

<template>
  
    <input v-if="document" type="text" 
      class="input input-sm text-base py-0 border-0 outline-0 bg-base-200 cursor-pointer"  
      v-model="document.title"
      @blur="saveDocument"
    />

</template>